export const CGP_OBJECT_NAME = 'CGP';
export const ALL_CONFIGS_KEY = '$allConfigs';
export const PWA_PROMPT_EVENT = "pwaPromptEvent";
export const PWA_PROMPT_CALLBACK = "pwaPromptCallback";
export const PWA_INSTALLED_CALLBACK = "pwaInstalledCallback";
export const PWA_ISCSTATUS_LOCAL_STORAGE_KEY = "orbit-pwa-iscstatus";
